import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgServiceabonnement = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M31.33 23.36a5.67 5.67 0 0 0-5.46-1.48l-7.06-7.06-2.94 5.03 6.02 6.02c-.5 1.88 0 3.98 1.48 5.46a5.67 5.67 0 0 0 5.46 1.48l-3.47-3.47 3.99-3.99 3.47 3.47c.5-1.88 0-3.98-1.48-5.46z"
    />
    <path
      fill="#F170B8"
      d="M20.15 33h-4.66L9.42 18.86l4.72-2.02 3.76 8.77 8.02-17.36 4.66 2.16z"
    />
    <path
      fill="#00215B"
      d="M17.86 31.57h-4.97l-3.35-7.76.92-.4 3.09 7.16h4.31z"
    />
    <path
      fill="#F8BADD"
      d="M18.12 14.13c.5-1.88 0-3.98-1.48-5.46s-3.58-1.98-5.46-1.48l3.47 3.47-3.99 3.99-3.47-3.47c-.5 1.88 0 3.98 1.48 5.46s3.58 1.98 5.46 1.48l1.74 1.74 2.94-5.03-.69-.69z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgServiceabonnement);

export default ForwardRef;
